// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Sidebar Css*/
.sidebar {
  background: #ffffff;
  color: #ffffff;
  transition: all 0.3s;
  position: fixed;
  height: 100vh;
  min-width: 240px;
  max-width: 240px;
  border-right: 1px solid #E4E7F0;
  padding: 1rem 0;
}

ul {
  padding: 0;
}

ul li {
  list-style-type: none;
}

.sidebar li svg {
  position: relative;
  top: -1px;
}

.sidebar li a {
  display: block;
  padding: 4px 16px;
  margin: 1rem 0;
}

.sidebar li.active a, .sidebar li a:hover {
  background: #F4F6FA;
  color: #222735 !important;
  border-right: 4px solid #11BC97;
}

.sidebar ul li.active svg path, .sidebar li a:hover svg path {
  fill: #11BC97;
}

.sidebar a.link-disabled {
  opacity: 0.5;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AACA,cAAA;AACA;EACC,mBCHa;EDIb,cCJa;EDKb,oBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACC,+BAAA;EACA,eAAA;AAAF;;AAEA;EACE,UAAA;AACF;;AACA;EACE,qBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,SAAA;AAGF;;AADA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAIF;;AAFA;EACE,mBChBe;EDiBf,yBAAA;EACA,+BAAA;AAKF;;AAHA;EACE,aChCW;ADsCb;;AAHA;EACE,YAAA;EACA,oBAAA;AAMF","sourcesContent":["@import './colors';\n/*Sidebar Css*/\n.sidebar {\n\tbackground: $color-white;\n\tcolor: $color-white;\n\ttransition: all 0.3s;\n\tposition: fixed;\n\theight: 100vh;\n\tmin-width: 240px;\n\tmax-width: 240px;\n  border-right: 1px solid $color-normalGrey;\n  padding: 1rem  0;\n}\nul{\n  padding: 0;\n}\nul li{\n  list-style-type: none;\n}\n.sidebar li svg{\n  position: relative;\n  top: -1px;\n}\n.sidebar li a{\n  display: block;\n  padding: 4px 16px;\n  margin: 1rem 0;\n}\n.sidebar li.active a, .sidebar li a:hover{\n  background: $color-lightGrey;\n  color: $color-monoIntenseGrey !important;\n  border-right: 4px solid $color-green;\n}\n.sidebar ul li.active svg path, .sidebar li a:hover svg path{\n  fill: $color-green;\n}\n\n.sidebar a.link-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
